import { Routes, Route } from 'react-router-dom';
import Welcome from '@/pages/welcome/WelcomePage';
import AppLayout from '@/layouts/AppLayout';
import Dashboard from '@/pages/dashboard/index/DashboardPage';
import NewsIndex from '@/pages/dashboard/index/news/NewsIndexPage';
import NewsDetail from '@/pages/dashboard/index/news/NewsDetailPage';
import Folders from '@/pages/folders/index/FoldersPage';
import MediaDetail from '@/pages/folders/pictures/MediaDetailPage';
import Procedures from '@/pages/procedures/index/ProceduresPage';
import ProcedureDetail from '@/pages/procedures/procedure/index/ProcedureDetailPage';
import ProcedureCreate from '@/pages/procedures/create/ProcedureCreatePage';
import ProceduresArchives from '@/pages/procedures/archives/ProceduresArchivesPage';
import ProcedureEdit from '@/pages/procedures/procedure/edit/ProcedureEditPage';
import ProcedureInvitations from '@/pages/procedures/procedure/invitations/ProcedureInvitationsPage';
import ProcedurePreview from '@/pages/procedures/procedure/preview/ProcedurePreviewPage';
import ProcedureReport from '@/pages/procedures/reports/report/index/ProcedureReportPage';
import ProcedureReportCreate from '@/pages/procedures/reports/create/ProcedureReportCreatePage';
import ProcedureReportEdit from '@/pages/procedures/reports/report/edit/ProcedureReportEditPage';
import Tokens from '@/pages/tokens/index/TokensPage';
import Account from '@/pages/account/index/AccountPage';
import Subsidiary from '@/pages/subsidiary/index/SubsidiaryPage';
import Permissions from '@/pages/permissions/PermissionsPage';
import HelpPage from '@/pages/help/index/HelpPage';
import Devices from '@/pages/devices/index/DevicesPage';
import Search from '@/pages/search/SearchPage';
import VerifyEmail from '@/pages/verify-email/VerifyEmailPage';
import InviteLandingPage from '@/pages/public/invite/index/InviteLandingPage';
import InviteReportPage from '@/pages/public/invite/report/InviteReportPage';
import InviteSuccessPage from '@/pages/public/invite/success/InviteSuccessPage';
import CertificateVerifyPage from '@/pages/public/certificate/CertificateVerifyPage';
import { RequireAuth } from '@/lib/guards/RequireAuth';
import { RequireGuest } from '@/lib/guards/RequireGuest';
import { RequireGuestAuth } from '@/lib/guards/RequireGuestAuth';
import { BalanceProvider } from '@/lib/contexts/balance-context';
import { GuestAuthProvider } from '@/lib/contexts/guest-auth-context';
import PublicLayout from '@/layouts/PublicLayout';

export default function Router() {
    return (
        <Routes>
            {/* Routes publiques */}
            <Route path="/" element={<Welcome />} />
            <Route
                path="/login"
                element={
                    <RequireGuest>
                        <Welcome defaultView="login" />
                    </RequireGuest>
                }
            />
            <Route
                path="/register"
                element={
                    <RequireGuest>
                        <Welcome defaultView="register" />
                    </RequireGuest>
                }
            />
            <Route path="/forgot-password" element={<Welcome defaultView="forgot-password" />} />
            <Route path="/reset-password" element={<Welcome defaultView="reset-password" />} />
            <Route path="/create-password" element={<Welcome defaultView="create-password" />} />
            <Route path="/verify-email" element={<VerifyEmail />} />

            {/* Vérification publique d'un certificat photo (numéro + clé d'accès) */}
            <Route path="/certificat" element={<CertificateVerifyPage />} />
            {/* Adresse imprimée dans les certificats PDF et leur QR code (white_label.endpoints.certificate_page) */}
            <Route path="/certificate" element={<CertificateVerifyPage />} />

            {/* Routes publiques pour les invitations de procédure */}
            <Route element={<PublicLayout />}>
                <Route element={<GuestAuthProvider />}>
                    <Route path="/public/invite/:uuid" element={<InviteLandingPage />} />
                    <Route
                        path="/public/invite/:uuid/report"
                        element={
                            <RequireGuestAuth>
                                <InviteReportPage />
                            </RequireGuestAuth>
                        }
                    />
                    <Route path="/public/invite/:uuid/success" element={<InviteSuccessPage />} />
                </Route>
            </Route>

            {/* Search - Route protégée sans layout */}
            <Route
                path="/search"
                element={
                    <RequireAuth>
                        <Search />
                    </RequireAuth>
                }
            />

            {/* Routes protégées avec layout partagé */}
            <Route
                element={
                    <RequireAuth>
                        <BalanceProvider>
                            <AppLayout />
                        </BalanceProvider>
                    </RequireAuth>
                }
            >
                {/* Dashboard */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/news" element={<NewsIndex />} />
                <Route path="/dashboard/news/:newsId" element={<NewsDetail />} />

                {/* Tokens */}
                <Route path="/tokens" element={<Tokens />} />

                {/* Settings */}
                <Route path="/settings/account" element={<Account />} />
                <Route path="/settings/company" element={<Account />} />
                <Route path="/settings/superadmin" element={<Account />} />
                <Route path="/settings/superadmin/:subTab" element={<Account />} />
                <Route path="/settings/subsidiary/:subsidiaryId" element={<Subsidiary />} />
                <Route path="/settings/permissions" element={<Permissions />} />

                {/* Folders */}
                <Route path="/folders" element={<Folders />} />
                <Route path="/folders/*" element={<Folders />} />

                {/* Media (pictures + videos) — page partagée, le rendu s'adapte au mime */}
                <Route path="/pictures/:pictureId" element={<MediaDetail type="picture" />} />
                <Route path="/videos/:pictureId" element={<MediaDetail type="video" />} />

                {/* Procedures */}
                <Route path="/procedures" element={<Procedures />} />
                <Route path="/procedures/archives" element={<ProceduresArchives />} />
                <Route path="/procedures/create" element={<ProcedureCreate />} />
                <Route path="/procedures/create/preview" element={<ProcedurePreview />} />
                <Route path="/procedures/:procedureId" element={<ProcedureDetail />} />
                <Route path="/procedures/:procedureId/edit" element={<ProcedureEdit />} />
                <Route path="/procedures/:procedureId/edit/preview" element={<ProcedurePreview />} />
                <Route path="/procedures/:procedureId/invitations" element={<ProcedureInvitations />} />
                <Route path="/procedures/:procedureId/reports/create" element={<ProcedureReportCreate />} />
                <Route path="/procedures/:procedureId/reports/:reportId" element={<ProcedureReport />} />
                <Route path="/procedures/:procedureId/reports/:reportId/edit" element={<ProcedureReportEdit />} />

                {/* [DISABLED] Devices / Sessions — décommentez pour réactiver */}
                <Route path="/settings/devices" element={<Devices />} />

                {/* Help */}
                <Route path="/help" element={<HelpPage />} />
            </Route>
        </Routes>
    );
}
